import timelineFilterOptionConstant from '../@constants/timelineFilterOption.constant'

export default [
  {
    label: 'All updates',
    value: timelineFilterOptionConstant.ALL_UPDATES,
  },
]
